import { EMPTY_LIST } from '@/lib/utils';
import { SummaryTile } from './SummaryTile';
import styles from './SummaryTileRow.module.scss';

/**
 * Props:
 *   tiles  Array<{ label, value }> — each its own card, spaced apart
 */
// The fulfill screens' row: separate cards with a gap, not <SummaryTiles>' joined card.
export const SummaryTileRow = ({ tiles = EMPTY_LIST }) =>
  tiles.length === 0 ? null : (
    <div className={styles.row}>
      {tiles.map(({ label, value }) => (
        <SummaryTile key={label} label={label} value={value} className={styles.card} />
      ))}
    </div>
  );
